import type { Translations } from './en.js';

const id: Translations = {
  ok: 'OK',
  cancel: 'Batal',
  close: 'Tutup',
  confirm: 'Konfirmasi',
  language: 'Bahasa',

  game_title: 'Tingkatkan Pedang',
  tap_to_start: 'Ketuk untuk mulai',
  title_load_failed: 'Gagal memuat gambar judul:',
  game_started: 'Tingkatkan Pedang dimulai!',

  level_label: 'Lv.{n}',
  gold_suffix: 'G',
  rate_suffix: '%',
  rate_clear: '🎉 Semua selesai!',
  rate_display: '{rate}%',
  rate_display_boosted: '{rate}% ⬆',
  gold_display: '{amount} G',
  gold_display_free: '0 G (Gratis!)',

  btn_enhance: '⚒️ Tingkatkan',
  btn_enhance_ready: '⚔️ Tingkatkan',
  btn_enhance_complete: '🏆 Selesai',
  btn_free_enhance: '▶ Peningkatan gratis',
  btn_exhausted: 'Habis',
  btn_boost: 'Naikkan\nPeluang',
  btn_applying: 'Aktif\n!',
  btn_protection_active: '🛡️ Perlindungan aktif',
  btn_protection_use: '🛡️ Gunakan gulungan',
  btn_sell: '💰 Jual',
  btn_sell_amount: '💰 {amount}G',
  btn_shop: '🏪 Toko',
  cost_max: 'MAX',
  cost_free: '0 G (Gratis!)',

  tab_settings: '⚙️ Pengaturan',
  tab_inventory: '📦 Inventaris',
  bgm_on: '🎵 Musik ON',
  bgm_off: '🎵 Musik OFF',
  sfx_on: '🔊 Efek ON',
  sfx_off: '🔊 Efek OFF',
  inventory_title: '⚔️ Senjata tersimpan',
  inventory_empty: 'Tidak ada senjata tersimpan',
  equip: 'Pakai',
  equip_msg: '{name} dipakai!',
  reset_confirm_title: '⚠️ Reset semua?',
  reset_confirm_desc: 'Semua progres akan dihapus',
  reset: 'Reset',
  reset_start_over: '🔄 Mulai dari awal',
  menu_close: 'Tutup',

  inv_scrolls_title: '🛡️ Gulungan perlindungan',
  inv_scrolls_line1: 'Dasar: {c0}  |  Menengah: {c1}',
  inv_scrolls_line2: 'Tinggi: {c2}  |  Ultra: {c3}',
  inv_weapon_entry: '{name} (Lv.{level})',

  ad_gold_title: 'Tonton iklan untuk peningkatan gratis',
  ad_gold_desc: 'Peningkatan berikutnya 0 emas',
  ad_gold_note: '(Gulungan & Peluang UP tetap aktif)',
  ad_gold_confirm: '▶ Tonton iklan',
  ad_gold_free_next: 'Peningkatan berikutnya gratis!',
  ad_gold_exhausted: 'Pemakaian habis!',
  ad_gold_remaining: 'Sisa: {current}/3',

  boost_popup_title: '📺 Tonton iklan',
  boost_confirm: '▶ Tonton iklan untuk aktif',
  boost_close: 'Tutup',
  boost_applied: 'Peningkatan peluang aktif!',
  boost_already_applied: 'Sudah aktif!',
  boost_exhausted: 'Pemakaian habis!',
  boost_remaining: '🎬 Sisa pemakaian: {current}/3',
  boost_popup_desc: 'Saat ini {rate}% → x{mult}',
  boost_rate_display: '{rate}%',
  boost_mult_2x: 'x2',
  boost_mult_1_5x: 'x1.5',
  boost_mult_1_3x: 'x1.3',

  protection_popup_title: '🛡️ Gunakan gulungan',
  protection_use: 'Gunakan',
  protection_cancel: 'Batal',
  protection_popup_info:
    'Level saat ini: Lv.{level}\nButuh: {name} x1\nKamu punya: {count}',
  protection_activated: '{name} diaktifkan!',
  protection_returned: '{name} dikembalikan',
  protection_protected: '🛡️ Dilindungi gulungan!',

  msg_max_level: 'Sudah di level maks!',
  msg_gold_short: 'Emas tidak cukup!',
  msg_success_boost: 'Peningkatan boost berhasil!',
  msg_success: 'Peningkatan berhasil!',
  msg_destroyed: '💥 HANCUR!',

  shop_title: 'Toko',
  tab_protection: 'Perlindungan',
  tab_weapons: 'Beli senjata',
  weapon_shop_title: '⚔️ Beli senjata',
  item_free: 'Gratis',
  close_shop: 'Tutup',
  buy_complete_title: 'Pembelian selesai!',
  buy_complete_desc: 'Barang dibeli tersedia di\nPengaturan (atas) → 📦 Inventaris.',
  buy_complete_ok: 'OK',
  scroll_shop_label: '{name} (Lv.{min}-{max})',
  scroll_purchased: '{name} didapat!',
  weapon_moved_to_inventory: '{name} → Inventaris',
  price_display: '{amount}G',
  sell_received: '+{amount}G!',

  destroy_title: 'Senjata hancur',
  destroy_ad_restore: '▶ Tonton iklan, pulihkan',
  destroy_restore_ad: 'Tonton iklan, pulihkan ({current}/{max})',
  destroy_give_up: 'Mulai dari awal',
  destroy_restore_count: '🎬 Kesempatan pulihkan: {current}/{max}',
  destroy_restored: 'Lv.{level} weapon restored!',
  ad_watch_fail: 'Iklan gagal diputar',
  weapon_restored: '{name} dipulihkan!',

  completion_title: 'Kamu menyelesaikan pedang terkuat!',
  completion_all_done: '🏆 Semua peningkatan selesai! 🏆',
  congrats_text: '🎉 Selamat! 🎉',
  register_name: '✏️ Daftar nama',
  prompt_register_name: 'Masukkan nama untuk Hall of Fame:',
  no_completion: 'Belum ada yang menyelesaikan',
  be_first: 'Jadilah yang pertama!',
  completion_close: 'Tutup',
  leaderboard_title: '📋 Hall of Fame',
  leaderboard_entry: '#{rank} - {name}',
  completion_rank_msg: 'Kamu penyelesai ke-{rank}!',
  completion_total_msg: '{total} pemain telah menyelesaikan',

  weapon_image_load_failed: 'Gagal memuat gambar senjata:',

  weapon_0: 'Tangan kosong',
  weapon_1: 'Belati biasa',
  weapon_2: 'Pedang besi',
  weapon_3: 'Pedang perak',
  weapon_4: 'Pedang snowboard',
  weapon_5: 'Pedang ombak',
  weapon_6: 'Pedang gadis ajaib',
  weapon_7: 'Pedang beruang',
  weapon_8: 'Pedang tengkorak membara',
  weapon_9: 'Pedang petir',
  weapon_10: 'Belati cahaya bulan',
  weapon_11: 'Pedang naga',
  weapon_12: 'Pedang berotot',
  weapon_13: 'Pedang raja berlian',
  weapon_14: 'Tombak naga biru',
  weapon_15: 'Pedang kuno',
  weapon_16: 'Pedang ganda raja bajak laut',
  weapon_17: 'Pedang kenyal Dubai',
  weapon_18: 'Pedang Tujuh-Tujuh',
  weapon_19: 'Tongkat-pedang ajaib',
  weapon_20: 'Pedang berdengung',
  weapon_21: 'Pedang palet',
  weapon_22: 'Pedang alam',
  weapon_23: 'Pedang cyborg',
  weapon_24: 'Pedang lubang hitam',
  weapon_25: 'Pedang burung emas',
  weapon_26: 'Pedang kristal kekuatan',
  weapon_27: 'Pedang naga gelap',
  weapon_28: 'Pedang capit',
  weapon_29: 'Pedang AI',
  weapon_30: 'Pedang gergaji',
  weapon_31: 'Pedang bintang jatuh',
  weapon_32: 'Pedang sangat gelap',
  weapon_33: 'Pedang galaksi',
  weapon_34: 'Pedang berlian super mahal',

  scroll_basic: 'Gulungan perlindungan dasar',
  scroll_mid: 'Gulungan perlindungan menengah',
  scroll_hi: 'Gulungan perlindungan tinggi',
  scroll_ultra: 'Gulungan perlindungan ultra',
  scroll_label_basic: 'Dasar',
  scroll_label_mid: 'Menengah',
  scroll_label_hi: 'Tinggi',
  scroll_label_ultra: 'Ultra',

  // === Materials (Sprint 1) ===
  mat_iron_dust: 'Debu Besi',
  mat_refining_core: 'Inti Penyulingan',
  mat_lava_essence: 'Esensi Lava',
  mat_abyss_crystal: 'Kristal Jurang',

  mat_drop_notice: '+{amount} {name}',
  mat_drop_title: 'Material Diperoleh!',
  mat_double_ad: 'Tonton Iklan x2',
  mat_doubled: 'x2 Diterapkan!',
  mat_panel_title: 'Material',

  // === Keep / Weapon Inventory (Sprint 1) ===
  keep_btn: 'Simpan',
  keep_full: 'Penyimpanan Penuh!',
  keep_lv1_blocked: 'Senjata Lv.1 tidak dapat disimpan',
  keep_success: '{name} disimpan!',
  keep_retrieve: 'Pasang',
  keep_sell: 'Jual',
  keep_slot_expand: 'Perluas Slot',
  keep_slot_cost: '{amount}G',
  keep_slot_max: 'MAX',
  keep_slot_count: 'Slot: {used}/{total}',
  keep_panel_title: 'Senjata Tersimpan',
  keep_empty: 'Tidak ada senjata tersimpan',
  keep_weapon_entry: 'Lv.{level} {name}',
  keep_sell_received: '+{amount}G',
  keep_no_slot: 'Perluas slot Anda!',

  // === Tungku (Sprint 2) ===
  tab_forge: 'Tungku',
  forge_title: 'Tungku',
  forge_tab_weapon: 'Senjata',
  forge_tab_scroll: 'Gulungan',
  forge_tab_upgrade: 'Tingkatkan Mat.',
  forge_craft_btn: 'Buat',
  forge_craft_success: '{name} berhasil dibuat!',
  forge_not_enough_mat: 'Material tidak cukup',
  forge_weapon_to_equip: 'Pasang sekarang?',
  forge_weapon_to_keep: 'Simpan',
  forge_weapon_equip: 'Pasang',
  forge_keep_full_equip: 'Penyimpanan penuh — langsung dipasang.',
  forge_cost_label: 'Biaya:',
  forge_result_label: 'Hasil:',

  forge_recipe_weapon_lv5: 'Buat Senjata Lv.5',
  forge_recipe_weapon_lv10: 'Buat Senjata Lv.10',
  forge_recipe_weapon_lv15: 'Buat Senjata Lv.15',
  forge_recipe_weapon_lv21: 'Buat Senjata Lv.21 (Jaminan)',
  forge_recipe_weapon_lv21_desc: 'Dapatkan senjata Lv.21 langsung — tanpa upgrade, tanpa gagal!',
  forge_recipe_scroll_basic: 'Buat Gulungan Dasar',
  forge_recipe_scroll_mid: 'Buat Gulungan Menengah',
  forge_recipe_scroll_hi: 'Buat Gulungan Tinggi',
  forge_recipe_scroll_ultra: 'Buat Gulungan Ultra',
  forge_recipe_upgrade_1: 'Debu Besi → Inti Olahan',
  forge_recipe_upgrade_2: 'Inti Olahan → Esens Lava',
  forge_recipe_upgrade_3: 'Esens Lava → Kristal Jurang',

  scroll_effect_basic: 'Cegah kehancuran saat gagal (Lv.1-9)',
  scroll_effect_mid: 'Cegah kehancuran saat gagal (Lv.10-19)',
  scroll_effect_hi: 'Cegah kehancuran saat gagal (Lv.20-24)',
  scroll_effect_ultra: 'Cegah kehancuran saat gagal (Lv.25-34)',
  scroll_buy_btn: 'Beli',

  keep_card_equip: 'Pasang',
  keep_card_sell: 'Jual',
  keep_slot_empty: 'Kosong',

  sacrifice_btn: 'Korbankan Senjata',
  sacrifice_panel_title: 'Korbankan Senjata',
  sacrifice_panel_desc: 'Korbankan senjata Lv.{level} meningkatkan sukses +{tierPct}% per unit',
  sacrifice_empty: 'Tidak ada senjata Lv.{level} di penyimpanan',
  sacrifice_bonus_label: 'Bonus: +{pct}%',
  sacrifice_cap_label: '({count}/{cap})',
  sacrifice_offer_btn: 'Korbankan',
  sacrifice_ad_slots: 'Tonton iklan: +{pct}% peluang sukses',
  sacrifice_ad_exhausted: 'Batas iklan tercapai',
  sacrifice_ad_granted: '+3 pengorbanan ditambahkan!',
  sacrifice_added: 'Pengorbanan diterima! +{tierPct}% bonus',
  sacrifice_cap_reached: 'Batas pengorbanan tercapai',
  sacrifice_reset: 'Bonus pengorbanan direset',

  infinity_btn: 'Infinity',
  infinity_active: 'GRATIS {sec}d',
  infinity_popup_title: 'Mode Infinity',
  infinity_popup_desc: 'Tingkatkan sepuasnya 10 detik, tanpa emas!\nPeluangnya sama — bisa tetap hancur!',
  infinity_popup_confirm: 'Tonton Iklan',
  infinity_popup_close: 'Tutup',
  infinity_cooldown: 'Siap dalam {sec}d',
  infinity_daily_exhausted: 'Batas harian tercapai',
  infinity_started: 'Mode Infinity ON! Gratis 10d',
  infinity_ended: 'Mode Infinity selesai',

  buff_item_luck_charm: 'Jimat Keberuntungan',
  buff_item_guarantee: 'Tiket Jaminan',
  buff_item_destroy_guard: 'Pelindung Anti-Rusak',
  buff_item_use: 'Gunakan',
  buff_item_active: 'Aktif',
  buff_item_empty: '0',
  buff_luck_charm_activated: 'Jimat aktif! +5% penguatan berikutnya',
  buff_guarantee_activated: 'Tiket aktif! Penguatan berikutnya 100%',
  buff_destroy_guard_activated: 'Pelindung aktif! Gagal berikutnya senjata tidak rusak',
  buff_luck_charm_consumed: 'Jimat habis digunakan',
  buff_guarantee_consumed: 'Tiket habis digunakan',
  buff_destroy_guard_consumed: 'Pelindung habis digunakan — senjata diselamatkan!',
  buff_item_already_active: 'Sudah aktif!',
  buff_item_none: 'Tidak ada {name}',
  buff_popup_count: 'Kamu punya: {count}',
  buff_popup_use_btn: 'Gunakan Sekarang',
  buff_popup_no_stock: 'Tidak punya. Buat di Tungku.',
  buff_popup_luck_charm_effect: '+5% tingkat sukses pada penguatan berikutnya',
  buff_popup_guarantee_effect: 'Penguatan berikutnya dijamin 100% sukses',
  buff_popup_destroy_guard_effect: 'Jika penguatan berikutnya gagal, senjata TIDAK akan rusak',

  forge_recipe_item_luck_charm: 'Buat Jimat Keberuntungan',
  forge_recipe_item_luck_charm_desc: '+5% tingkat sukses pada penguatan berikutnya',
  forge_recipe_item_guarantee: 'Buat Tiket Jaminan',
  forge_recipe_item_guarantee_desc: 'Penguatan berikutnya 100% sukses',
  forge_recipe_item_destroy_guard: 'Buat Pelindung Anti-Rusak',
  forge_recipe_item_destroy_guard_desc: 'Senjata TIDAK rusak pada kegagalan berikutnya',
  forge_tab_item: 'Item',
};

export default id;
